import { shortenAddress } from "@usedapp/core";
import { Badge } from "antd";
import React from "react";
import {
  ButtonSpan,
  DeadlineSpan,
  DeadlineSpanHeading,
  EpochButton,
  FunctionButton,
  ListTitle,
  TutorialButtondiv,
  TutorialDiv,
  TutorialSpan,
  TutorialSpanHeading,
  TutorialSubTitle,
} from "..";
import { shortenBytesData } from "../../utils";
import Tutorial from "../Tutorial";

const JobDetail = ({ executeJob, expireJob, selectedJob }) => {
  console.log("selectedJob: ", selectedJob);
  return (
    <>
      <TutorialDiv>
        {selectedJob ? (
          <>
            <div style={{ display: "flex" }}>
              <ListTitle
                style={{
                  color: "#130e1b",
                  marginTop: "1rem",
                  marginLeft: "2rem",
                  flexGrow: 1,
                }}
              >
                {selectedJob.name}
              </ListTitle>
              <div
                style={{
                  marginTop: "1.2rem",
                  marginRight: "2rem",
                  display: "flex",
                }}
              >
                <FunctionButton
                // onClick={() => {
                //   executeJob(i);
                // }}
                >
                  <ButtonSpan style={{ fontSize: "12px" }}>
                    <Badge status="success" />
                    {selectedJob.runOnce ? "Not Reccurring" : "Reccurring"}
                  </ButtonSpan>
                </FunctionButton>
                <FunctionButton
                  style={{ marginLeft: "0.5rem" }}
                  // onClick={() => {
                  //   expireJob(i);
                  // }}
                >
                  <ButtonSpan style={{ fontSize: "12px" }}>
                    <Badge status="success" />
                    {selectedJob.isExpired ? "Inactive" : "Active"}
                  </ButtonSpan>
                </FunctionButton>
              </div>
            </div>
            <TutorialSubTitle style={{ marginTop: "1.75rem" }}>
              <TutorialSpanHeading>Initiator: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {shortenAddress(selectedJob.initiatorAddress)}
              </TutorialSpan>
            </TutorialSubTitle>

            <TutorialSubTitle>
              <div style={{ flexGrow: 1, display: "flex" }}>
                <TutorialSpanHeading>Destination: </TutorialSpanHeading>{" "}
                <TutorialSpan>
                  {shortenAddress(selectedJob.executionContract)}
                </TutorialSpan>
              </div>
            </TutorialSubTitle>

            <TutorialSubTitle>
              <TutorialSpanHeading>Created On: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {new Date(
                  selectedJob.createdTimestamp.toNumber() * 1000
                ).toLocaleString()}
              </TutorialSpan>
            </TutorialSubTitle>
            <TutorialSubTitle>
              <TutorialSpanHeading>Job Type: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {parseInt(selectedJob.jobType) === 0
                  ? "Protocol Module"
                  : "Arbitrary Job"}
              </TutorialSpan>
            </TutorialSubTitle>
            <TutorialSubTitle>
              <TutorialSpanHeading>Run Every (seconds): </TutorialSpanHeading>{" "}
              <TutorialSpan>{selectedJob.executionInterval}</TutorialSpan>
            </TutorialSubTitle>
            <TutorialSubTitle>
              <TutorialSpanHeading>Is Strict Execution: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {selectedJob.strictExecution ? "Strictly" : "Unstrict"}
              </TutorialSpan>
            </TutorialSubTitle>
            {/* <TutorialSubTitle>
              <TutorialSpanHeading>Is Strict Execution: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {selectedJob.strictExecution ? "Strictly" : "Unstrict"}
              </TutorialSpan>
            </TutorialSubTitle> */}
            <TutorialSubTitle>
              <TutorialSpanHeading>Function Signature: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {selectedJob.functionSignature.toString()}
              </TutorialSpan>
            </TutorialSubTitle>
            <TutorialSubTitle>
              <TutorialSpanHeading>Execution Data: </TutorialSpanHeading>{" "}
              <TutorialSpan>
                {shortenBytesData(selectedJob.data.toString())}
              </TutorialSpan>
            </TutorialSubTitle>
            <TutorialSubTitle>
              <DeadlineSpanHeading style={{ flexGrow: 1 }}>
                Deadline:
              </DeadlineSpanHeading>{" "}
              <DeadlineSpan style={{ marginRight: "2rem" }}>
                {new Date(
                  selectedJob.nextExecutionDeadline.toNumber() * 1000
                ).toLocaleString()}
              </DeadlineSpan>
            </TutorialSubTitle>
            <TutorialButtondiv>
              {!selectedJob.isExpired ? (
                <>
                  <EpochButton
                    style={{ flexGrow: 1, minWidth: "11rem" }}
                    onClick={() => {
                      executeJob(selectedJob.id);
                    }}
                  >
                    <ButtonSpan>Execute Job</ButtonSpan>
                  </EpochButton>

                  <EpochButton
                    style={{ minWidth: "11rem" }}
                    onClick={() => {
                      expireJob(selectedJob.id);
                    }}
                  >
                    <ButtonSpan>Expire Job</ButtonSpan>
                  </EpochButton>
                </>
              ) : null}
            </TutorialButtondiv>
          </>
        ) : (
          <Tutorial />
        )}
      </TutorialDiv>
    </>
  );
};

export default JobDetail;
